import React, { Component, Suspense } from 'react';
import PropTypes from 'prop-types';
import { withRouter, matchPath } from 'react-router-dom';
import Shortcuts from '../UI/Shortcut';
import routes from '../../routes/routes';
import { withTranslation } from 'react-i18next';
import NavigationMobileShortcut from './NavMobileShortcut';
import { connect } from 'react-redux';
import mobileConfigActions from '../../actions/mobileConfig.actions';

function PageTitle({ mobileConfig, ...props }) {
  const deptId = JSON.parse(localStorage.getItem('userProfile')).departmentId;
  React.useEffect(() => {
    props.getMobileConfigsByDeptId(deptId);
  }, []);
  function getPresetName() {
    const mobileConfigId = localStorage.getItem('mobileConfigId') || 'default';
    if (mobileConfigId === 'default') {
      return 'Default';
    } else {
      const result = mobileConfig.mobileConfigs.filter(
        (mc) => mc.id === mobileConfigId,
      )[0];
      if (result) {
        return result.name;
      } else return '';
    }
  }
  return (
    <Suspense fallback="loading">
      <div className="page-title d-flex justify-content-between align-items-center">
        {/* <NavigationMobileShortcut /> */}
        <div>
          <h1>{getPresetName()}</h1>
        </div>
        <Shortcuts />
      </div>
    </Suspense>
  );
}

PageTitle.propTypes = {
  location: PropTypes.object.isRequired,
};

PageTitle.defaultProps = {
  title: '',
};

function mapStateToProps(state) {
  return {
    mobileConfig: state.mobileConfig,
  };
}

export default withRouter(
  withTranslation('app')(
    connect(mapStateToProps, mobileConfigActions)(PageTitle),
  ),
);
